<template>
	<div class="card mb-4">
		<div class="card-body reminder">
			<h2 class="card-title">諮詢</h2>
			<p class="card-text"></p>
			
			<ol start="52" class="qa-list">
				<li>
					<h5>什麼是ColleGo!系統？有哪些功能呢？</h5>
					<div class="qa-text">
						<img height="25" :src="content.qa" width="25" />
						<ol class="list-paren-num">
							<li>ColleGo! 取自英文College（大學）與Go（前往）組合而成，鼓勵探索、適性、前進。</li>
							<li>ColleGo! 提供「大學選才」、「高中育才」與「焦點話題」三個類別的資訊，內容豐富，特別設計了閱讀資料時需要的各項功能，包括比較功能、搜尋功能及個人化功能等。不論是高一、高二或高三學生，若不熟悉大學校系，也不知道如何選擇校系，ColleGo! 是可以幫上忙的。</li>
						</ol>
					</div>
				</li>
				<li>
					<h5>學群、學類、學系是什麼？</h5>
					<div class="qa-text">
				<img height="25" :src="content.qa" width="25" />ColleGo!可查詢近2000個大學校系，但校系數眾多查詢不易，因此目前ColleGo!取用大考中心之學群學類分類架構，此分類架構依興趣代碼與學習內容，把相近的學系歸為一個學類，將領域相近的學類集結為一個學群。目前本系統已發展132個學類（含7個學類層級之跨學類），並計有18個學群，進入ColleGo! 系統，就可以依學群、學類和對應的學系進行查詢與閱讀資訊。
			</div>
				</li>
				<li>
					<h5>ColleGo! 「大學選才」中有哪些功能對我認識校系有幫助呢？</h5>
					<div class="qa-text">
<img height="25" :src="content.qa" width="25" />除了從ColleGo!「大學選才」中的「認識學類」查看「對應校系」之外，還有比較功能和搜尋功能，能幫助你更聚焦在認識校系及選擇校系：
				<ol class="list-paren-num">
					<li>比較功能：可一次比較感興趣的三個學群、學類與學系，迅速掌握不同學群、學類、學系之間差異。</li>
					<li>搜尋功能：可利用特定關鍵字進行資訊查找，或選擇不同篩選條件進行進階搜尋，取得自己所需要的資料。</li>
				</ol>
			</div>
				</li>
				<li>
					<h5>ColleGo!「高中育才」內有什麼內容對我選擇校系有幫助呢？</h5>
					<div class="qa-text">
<img height="25" :src="content.qa" width="25" />「高中育才」包含五種「探索系列」模組、「探索生涯旅程」及「三年行動計畫」，其中「探索興趣類型」、「探索領域學科」二個探索模組，以及「探索生涯旅程」第八站很適合高三學生使用。
				<ol class="list-paren-num">
					<li>探索興趣類型：透過興趣代碼找到可能適合之學群、學類，再從學類往下探索到學系。</li>
					<li>探索領域學科：選擇自己感興趣或擅長的學科，參考重視該學科的學群、學類，再從學類往下探索到學系。</li>
					<li>探索生涯旅程第八站：選擇感興趣的校系至多三個，系統將針對與該系相近的知識領域及使用者最常比較的次數，提供更多延伸學系選項，並使學生依據嚮往及入學等雙向度所反映的分佈圖，協助其決策思考。</li>
				</ol>
			</div>
				</li>
				<li>
					<h5>我想知道就讀高中的課程地圖及開設課程，該如何查詢?</h5>
					<div class="qa-text">
<img height="25" :src="content.qa" width="25" />教育部國民及學前教育署已建置<a href="https://course.k12ea.gov.tw/CourseInformation/index.asp" target="_blank">「全國高級中等學校課程計畫平臺」</a> 羅列各所高中的基本資料、學校特色及課程地圖，讓學生與家長深入了解就讀的高中，協助學生探索生涯發展方向。在課程地圖上可以看到：
				<ol class="list-paren-num">
					<li>學校針對不同班別，在不同年級的課程規劃。</li>
					<li>同課程類型(部定必修、校訂必修、選修)開設的課程。</li>
					<li>學校的課程計畫，學校的基本資料、願景與學生圖像、學校特色項目、課程發展與規劃、團體活動時間及彈性學習時間的實施規劃、學校選課輔導流程機制等，以幫助學生認識高中三年的課程規劃。若擬進一步瞭解就讀高中之課程規劃，可直接洽詢就讀高中。</li>
				</ol>
			</div>
				</li>
			</ol>


			<!-- last -->
			<p></p>
		</div>
	</div>
</template>

<script>
export default {
    data() {
        return {
			content: {
                qa: require('page/_home/img/carousel/qa.png'),
            },
        }
    },
}
</script>
